import React from "react";
import axios from 'axios';
import io from 'socket.io-client';
import {putApi} from '../utils/functions';
import EventEmitter from '../utils/emmiter';

export default class TrackID {


	/*

		What we need to do is browse accross the network and see if we get any repsonse from any of the trackID softwares
		now playing 2,
		unboxed,
		seeqnc

		and remember which socket we are connected to
	*/

	#servicekey;
	#refNowPlaying;
	#refUnboxed;
	#refSeeqnc;

	constructor(props) {
		//console.log(props);
		this.servicekey = props.servicekey;
		this.refNowPlaying = React.createRef();
    //if (!this.refNowPlaying.current) this.refNowPlaying.current = io(`http://localhost:9000`, {secure: false});

		this.startNowPlaying();
	}


	//---- Now playing 2's functions
	uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

	async startNowPlaying() {
		return;
		this.refNowPlaying.current = io.connect(`http://localhost:9000`, {secure: false});
		this.refNowPlaying.current.on("connect", (data) => {
			const uuid = this.uuidv4();
			//console.log(this.refNowPlaying.current );

			this.refNowPlaying.current.emit('id', 'NowPlayingTrackReceivers');
			EventEmitter.emit('/template/trackid', {data: 'Now Playing 2'});

			setTimeout(()=>{

				this.refNowPlaying.current.once(uuid, (track) => {
					if( track.result ) {
						let params = new URLSearchParams();
						params.append('servicekey', this.servicekey);
						//if( track.result.album ) params.append('album', track.result.album);
						if( track.result.artist ) params.append('artist', track.result.artist);
						if( track.result.title ) params.append('title', track.result.title);
						if( track.result.label ) params.append('label', track.result.label);
						if( track.result.artwork && track.result.artwork.indexOf('http://') !== 0 ) params.append('artwork', track.result.artwork);
						putApi('/v3/template/trackid', params);
					}
				});

				this.refNowPlaying.current.emit('service-call', {
					from: 'NowPlayingTrackReceivers',
					to: 'NowPlayingHistory',
					fn: 'getCurrentTrack',
					args: [],
					responseId: uuid,
				});
			},500);
			

			//this.refNowPlaying.current.emit('id', 'NowPlayingTrackReceivers');
			//setTimeout(()=>{
				/*let settings = {...this.state.settings};
				settings.templates['Now Playing 2'] = [true, Math.floor(Date.now()/1000) ];
				this.setState({settings});*/
			//},2500);
		});
		this.refNowPlaying.current.on("disconnect", (data) => {
			//console.log("here!");
		});
		this.refNowPlaying.current.on("reload", (data) => {
		});
		
		this.refNowPlaying.current.on("trackUpdate", async (data) => {
			console.log("trackUpdate:", data);
			//if( this.state.validated === 1 ) {
				let params = new URLSearchParams();
				console.log(data.args[0]);
				params.append('servicekey', this.servicekey);
				//if( data.args[0].album ) params.append('album', data.args[0].album);
				if( data.args[0].artist ) params.append('artist', data.args[0].artist);
				if( data.args[0].title ) params.append('title', data.args[0].title);
				if( data.args[0].label ) params.append('label', data.args[0].label);
				if( data.args[0].artwork && data.args[0].artwork.indexOf('http://') !== 0 ) params.append('artwork', data.args[0].artwork);
				await putApi('/v3/template/trackid', params);
			//}
		});
		this.refNowPlaying.current.on("animate", (data) => {
		});
	}
	


}